import { Box } from "@itandi/itandi-bb-ui/Box";
import { Button } from "@itandi/itandi-bb-ui/Button";
import { FormControl } from "@itandi/itandi-bb-ui/FormControl";
import { FormControlText } from "@itandi/itandi-bb-ui/FormControlText";
import { FormGroup } from "@itandi/itandi-bb-ui/FormGroup";
import { Input } from "@itandi/itandi-bb-ui/Input";
import { InputCheckBox } from "@itandi/itandi-bb-ui/InputCheckBox";
import React from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { ConfirmModal } from "~/components/common/parts/modal/ConfirmModal";
import { useOpenHandler } from "~/hooks/useOpenHandler";
import type {
	AdminSettingCompanySetting,
	CompanySetting
} from "~/models/CompanySetting";
import { updateCompanyInformation } from "~/utils/api/admin/CompanySetting";
import { isSuccess } from "~/utils/api/api_handler";

type Props = {
	companySetting: CompanySetting;
};
export const CompanySettingForm: React.FC<Props> = ({ companySetting }) => {
	const { isOpen, handleOpen, handleClose } = useOpenHandler();
	const { register, watch, getValues, setValue, handleSubmit } =
		useForm<AdminSettingCompanySetting>({ defaultValues: companySetting });
	const fromMarket = watch("fromMarket");
	const useIaStaffLogin = watch("useIaStaffLogin");
	const onlyAmaterasProperties = watch("onlyAmaterasProperties");
	const onClickSubmit = React.useCallback(() => {
		handleSubmit(() => {
			handleOpen();
		})();
	}, [handleSubmit, handleOpen]);
	const handleAccept = React.useCallback(async () => {
		const values = getValues();
		const response = await updateCompanyInformation(values);
		if (isSuccess(response)) {
			toast.success("保存しました");
			handleClose();
			return;
		}
		toast.error("保存に失敗しました");
	}, [getValues, handleClose]);
	return (
		<Box width={360}>
			<FormGroup variant="vertical">
				<FormControl label="請求管理ロボ用請求先コード">
					<Input {...register("robotPaymentCode")} />
				</FormControl>
				<FormControl label="施工会社招待機能">
					<InputCheckBox
						//  UI上の「有効化」操作と、DBフラグ（from_market）の意味が逆転する形になるので反転する
						checked={!fromMarket}
						label="取引先の施工会社を追加・招待する"
						onChange={(e): void => {
							setValue("fromMarket", !e.currentTarget.checked);
						}}
					/>
					<FormControlText
						help={[
							"SaaS単体、またはSaaS+マケプレ導入の場合はチェックを入れてください",
							"チェックを入れると、管理会社一覧画面の反社チェックID入力ボタンは非表示になります"
						]}
					/>
				</FormControl>
				<FormControl label="物件情報の登録制御">
					<InputCheckBox
						checked={onlyAmaterasProperties}
						label="物件システムに登録されている物件のみ表示する"
						onChange={(e): void => {
							setValue("onlyAmaterasProperties", e.currentTarget.checked);
						}}
					/>
				</FormControl>
				<FormControl label="イタンジアカウントの担当者の利用">
					<InputCheckBox
						checked={useIaStaffLogin}
						label="イタンジアカウントの担当者を利用する"
						onChange={(e): void => {
							setValue("useIaStaffLogin", e.currentTarget.checked);
						}}
					/>
					<FormControlText help="有効化すると修繕システム上で担当者を追加・編集ができなくなります" />
				</FormControl>
			</FormGroup>
			<Button marginTop={16} onClick={onClickSubmit} variant="primary">
				保存
			</Button>
			<ConfirmModal
				confirmType="save"
				handleAccept={handleAccept}
				handleCancel={handleClose}
				isOpen={isOpen}
			>
				保存してよろしいですか？
			</ConfirmModal>
		</Box>
	);
};
